import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PartnerTableRow = ({ partner, onEdit, onViewLeads, onToggleStatus, onViewSalesforce, isSelected, onSelect }) => {
  const getStatusColor = (status) => {
    const colors = {
      verified: 'success',
      pending: 'warning',
      suspended: 'error',
    };
    return colors?.[status] || 'muted';
  };

  const getStatusIcon = (status) => {
    const icons = {
      verified: 'CheckCircle',
      pending: 'Clock',
      suspended: 'XCircle',
    };
    return icons?.[status] || 'Circle';
  };

  return (
    <tr className={`hover:bg-muted/20 transition-colors duration-200 ${isSelected ? 'bg-primary/5' : ''}`}>
      <td className="px-6 py-4">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(partner?.id, e?.target?.checked)}
          className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2"
          aria-label={`Select ${partner?.companyName}`}
        />
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Building" size={20} color="var(--color-primary)" />
          </div>
          <div className="min-w-0">
            <p className="font-medium text-foreground truncate">{partner?.companyName}</p>
            <p className="text-sm text-muted-foreground truncate">{partner?.industry}</p>
          </div>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="min-w-0">
          <p className="text-foreground truncate">{partner?.contactName}</p>
          <p className="text-sm text-muted-foreground truncate">{partner?.email}</p>
          <p className="text-sm text-muted-foreground">{partner?.phone}</p>
        </div>
      </td>
      <td className="px-6 py-4">
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-${getStatusColor(partner?.status)}/10 text-${getStatusColor(partner?.status)}`}>
          <Icon name={getStatusIcon(partner?.status)} size={14} />
          {partner?.status?.charAt(0)?.toUpperCase() + partner?.status?.slice(1)}
        </span>
      </td>
      <td className="px-6 py-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="text-foreground font-medium">{partner?.totalLeads}</span>
            <span className="text-muted-foreground text-sm">total</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-success font-medium">{partner?.convertedLeads}</span>
            <span className="text-muted-foreground text-sm">converted</span>
          </div>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="min-w-0">
          <p className="text-foreground">{partner?.registrationDate}</p>
          <p className="text-sm text-muted-foreground">Last: {partner?.lastActivity}</p>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="ExternalLink"
            onClick={() => onViewSalesforce(partner?.salesforceId)}
            title="View in Salesforce"
          />
          <Button
            variant="ghost"
            size="sm"
            iconName="FileText"
            onClick={() => onViewLeads(partner?.id)}
            title="View Leads"
          />
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit"
            onClick={() => onEdit(partner)}
            title="Edit Partner"
          />
          <Button
            variant="ghost"
            size="sm"
            iconName={partner?.status === 'suspended' ? 'CheckCircle' : 'Ban'}
            onClick={() => onToggleStatus(partner)}
            title={partner?.status === 'suspended' ? 'Activate' : 'Suspend'}
          />
        </div>
      </td>
    </tr>
  );
};

export default PartnerTableRow;